import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { MifirCountryIdentifier } from '../../Models/Domains/Regulations/MifirCountryIdentifier';
import { CountryCode } from '../../Constants/Enums/Domain/CountryCode';

declare var IS_RUNNING_IN_APP_POOL;

export class MifirCountryIdentifierClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(countryCode: CountryCode): Promise<Array<MifirCountryIdentifier>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Regulations/MifirCountryIdentifier/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { countryCode: countryCode }

    return AjaxWrapper.get<Array<MifirCountryIdentifier>, any>(url, data);
  }
}

